import axios from "axios";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import DaumPostCode from "react-daum-postcode";
import { root_url } from "../setting";

const JoinerParticipantForm = ({ formCheck, popupInfo, setIsUnique }) => {
  const { register, errors, getValues } = formCheck;
  const { popupShow, setPopupShow, address, onCompletePostCode } = popupInfo;

  return (
    <div className="mt-3">
      <Row className="text-md-center text-start text-custom-color mb-5">
        <h3>접수자 정보</h3>
      </Row>
      <Form.Group className="mb-5">
        <Form.Label className="fw-bold">단체명</Form.Label>
        <Row>
          <Col>
            <input
              type="text"
              className="form-in-class"
              placeholder="대덕구체육회"
              {...register("groupName", {
                required: true,
                maxLength: 50,
                pattern: /^[A-Z|a-z|가-힣\s]{2,50}$/g,
                onChange: () => {
                  setIsUnique(false);
                },
              })}
            />
          </Col>
          <Col>
            <Button
              className="border bg-custom-color mb-4"
              onClick={() => {
                let groupName = getValues("groupName");
                console.log(groupName);
                axios({
                  method: "get",
                  url: `${root_url}/api/isDuplicateTeamName?teamName=${groupName}`,
                })
                  .then((res) => {
                    if (res.status === 200) {
                      const { data } = res;
                      if (data) {
                        alert("중복입니다!");
                      } else {
                        alert("사용할 수 있습니다!");
                      }
                      setIsUnique(!data);
                    }
                  })
                  .catch((e) => {
                    console.log(e);
                    alert(
                      "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
                    );
                    return;
                  });
              }}
            >
              중복확인
            </Button>
          </Col>
        </Row>

        {errors.groupName && (
          <span
            className="position-absolute"
            style={{ fontSize: "0.8rem", color: "red" }}
          >
            (필수)단체명을 제대로 입력했나 확인해주세요.
          </span>
        )}
      </Form.Group>
      <Form.Group controlId="name" className="mb-5">
        <Form.Label className="fw-bold">이름</Form.Label>
        <input
          type="text"
          className="form-in-class"
          placeholder="홍길동"
          {...register("name", {
            required: true,
            maxLength: 50,
            pattern: /^[A-Z|a-z|가-힣]{2,50}$/g,
          })}
        />
        {errors.name && (
          <span
            className="position-absolute"
            style={{ fontSize: "0.8rem", color: "red" }}
          >
            (필수)이름을 공백없이 제대로 입력했나 확인해주세요.
          </span>
        )}
      </Form.Group>
      <Form.Group controlId="phone" className="mb-5">
        <Form.Label className="fw-bold">전화번호(-제외 11자 이내)</Form.Label>
        <input
          type="number"
          className="form-in-class"
          placeholder="01012345678"
          {...register("cellphone", {
            required: true,
            maxLength: 11,
            pattern:
              /^01[016789]\d{3,4}\d{4}$|^0(?!1[016789])\d{1,2}[2-9]\d{2,3}\d{4}$/,
          })}
        />
        {errors.cellphone && (
          <span
            className="position-absolute"
            style={{ fontSize: "0.8rem", color: "red" }}
          >
            (필수)전화번호는 4자 이상, 전화번호는 11자 이하의 숫자만
            입력해주세요.
          </span>
        )}
      </Form.Group>
      <Form.Group className="mb-5">
        <Form.Label className="fw-bold">주소</Form.Label>
        <Row>
          <Col>
            <Form.Control
              type="text"
              placeholder="우편번호"
              value={address.zonecode}
              onClick={() => setPopupShow((popupShow) => !popupShow)}
              onChange={() => console.log("")}
            />
          </Col>
          <Col>
            <Button
              className="border bg-custom-color mb-4"
              onClick={() => setPopupShow((popupShow) => !popupShow)}
            >
              우편번호 찾기
            </Button>
          </Col>
        </Row>

        <Form.Control
          type="text"
          placeholder="주소"
          onClick={() => setPopupShow(!popupShow)}
          value={
            address.roadAddress &&
            `${address.roadAddress}(${address.buildingName})`
          }
          onChange={() => {
            console.log("");
          }}
          className="mb-4"
        />
        <input
          type="text"
          className="form-in-class"
          placeholder="상세주소"
          {...register("detailAddress", {
            required: true,
          })}
        />
        {errors.detailAddress && (
          <span
            className="position-absolute"
            style={{ fontSize: "0.8rem", color: "red" }}
          >
            (필수)상세주소를 입력해주세요.
          </span>
        )}
      </Form.Group>
      <Modal
        show={popupShow}
        onHide={() => setPopupShow(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <DaumPostCode onComplete={onCompletePostCode} />
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default JoinerParticipantForm;
